import { GOOGLE_GEOCODE_API_BASE_URL } from "@/const";

export default {
  // use google maps api to get city, region (state/privince) and country
  methods: {
    async getLocationDetails(coords) {
      const {latitude, longitude} = coords;
      try {
        // get geocode data from google maps api
        const response = await fetch(
          GOOGLE_GEOCODE_API_BASE_URL+`?latlng=${latitude},${longitude}&key=${process.env.VUE_APP_GOOGLE_API}`
        );

        const data = await response.json();
        return data;
      } catch (error) {
        console.error(error);
      }
    },
    async getLocality(coords) {
      const locationDetails = await this.getLocationDetails(coords);
      // Only return country, region and city from google api response
      const address = {
        country: '',
        city: '',
      };

      locationDetails.results[0].address_components.forEach((component) => {
        if (component.types.includes('country')) {
          address.country = component.long_name;
        }

        if (component.types.includes('locality')) {
          address.city = component.long_name;
        }
      });

      return address;
    }
  },
}